import AsyncPage from '../AsyncPage'

import LogoutPage from './LogoutPage' // not worth async loading this page

class AsyncLogoutPageFactory extends AsyncPage {
  constructor() {
    super({})
  }
  getComponent() {
    return LogoutPage
  }
  // LogoutPage performs the sign-out itself so it can await the API call before
  // navigating away (see the comment there). Nothing to prepare here, and the
  // base implementation would only load the profile we are about to discard.
  async prepareAsyncData() {}
}

export default new AsyncLogoutPageFactory()
